module.exports = __webpack_public_path__ + "img/查看全部国内核心期刊.600bc12e.png";